import * as XLSX from "xlsx";
import { ExportOptions } from "./types";
import { sortData, downloadCSV, inferColumns } from "./helpers";

export function exportData(
  opts: ExportOptions,
  type: "xlsx" | "csv",
  outputName = "export"
) {
  if (type === "xlsx") {
    const wb = XLSX.utils.book_new();

    opts.sheets.forEach((sheet) => {
      const rows = sortData(sheet.data, sheet.sort);
      const cols = sheet.columns ?? inferColumns(rows);
      const keys = cols.map((c) => String(c.key));
      const labels = cols.map((c) => c.header ?? String(c.key));

      // Build AOA (array of arrays): first headers, then row values
      const aoa = [labels, ...rows.map((row) => keys.map((k) => row[k]))];

      // Generate worksheet from AOA
      const ws = XLSX.utils.aoa_to_sheet(aoa);

      // Apply column widths and formats
      ws["!cols"] = cols.map((c) => ({ wch: c.width ?? 10 }));
      rows.forEach((_, rowIdx) => {
        cols.forEach((col, colIdx) => {
          if (col.format) {
            const addr = XLSX.utils.encode_cell({ r: rowIdx + 1, c: colIdx });
            const cell = ws[addr];

            if (cell) cell.z = col.format;
          }
        });
      });

      XLSX.utils.book_append_sheet(wb, ws, sheet.sheetName);
    });

    XLSX.writeFile(wb, `${outputName}.xlsx`);
  } else {
    opts.sheets.forEach((sheet) => {
      const rows = sortData(sheet.data, sheet.sort);
      const cols = sheet.columns ?? inferColumns(rows);
      const keys = cols.map((c) => String(c.key));
      const labels = cols.map((c) => c.header ?? String(c.key));
      const dataRows = rows.map((row) => keys.map((k) => row[k]));

      downloadCSV(`${sheet.sheetName}.csv`, labels, dataRows);
    });
  }
}
